// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25eSJ","fullView":"styles_fullView__3n4ux"};